import { render } from "./SystemMessageList.vue?vue&type=template&id=22fe401e"
import script from "./SystemMessageList.vue?vue&type=script&lang=js"
export * from "./SystemMessageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/sys/systemMessage/SystemMessageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22fe401e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22fe401e', __exports__)) {
    api.reload('22fe401e', __exports__)
  }
  
  module.hot.accept("./SystemMessageList.vue?vue&type=template&id=22fe401e", () => {
    api.rerender('22fe401e', render)
  })

}


export default __exports__